import axios from './axios';

export const getClientSites = ({ params } = {}) => axios.get(`client_sites`, { params });
export const getClientSite = ({id, params }) => axios.get(`client_sites/${id}`, { params });
export const createClientSite = ({ data }) => axios.post('client_sites', data);
export const updateClientSite = ({ id, data }) => axios.put(`client_sites/${id}`, data);
export const deleteClientSite = ({ id }) => axios.delete(`client_sites/${id}`);